<template>
  <div class="reedit-song-edit">
    <div class="reedit-song-edit-time-box">
      <div class="reedit-song-edit-time">{{ `${renderData.startTime} / ${mediaUtil.formatTime(renderData.duration)}` }}</div>
      <!-- <div class="reedit-song-edit-time">
        {{ ) }}
      </div> -->
    </div>
    <div class="reedit-song-edit-main">
      <div class="reedit-song-edit-op fn-inline">
        <LoaderProgressCircle
          :size="48"
          default-color="rgba(255,255,255,0.75)"
          progress-color="#94ADFF"
          :progress="0"
        >
          <div class="audio-item-op flex-center" @click.stop="doTogglePlay">
            <i
              class="block"
              :class="{
                'isplay-true': !renderData.isPlaying,
                'isplay-false': renderData.isPlaying,
              }"
            ></i>
          </div>
        </LoaderProgressCircle>
      </div>
      <div class="reedit-song-edit-main-box fn-inline">
        <EditSelectAreaRender
          :url="props.url ?? audioUrl"
          :duration="props.duration"
          :waveformData="props.waveformData"
          ref="refDragSelect"
          @syncPlayState="doSyncPlayState"
          @syncProgress="doSyncProgress"
          @syncDuration="doSyncDuration"
          @syncWaveLoadingState="doSyncWaveLoadingState"
        ></EditSelectAreaRender>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
} from "vue";
import LoaderProgressCircle from "@/components/animation/LoaderProgressCircle.vue";
import EditSelectArea from "./editSelectArea.vue";
import EditSelectAreaExtend from "./editSelectAreaExtend.vue";
import mediaUtil from "@/components/media/utils/utils.js";

const audioUrl =
  "https://test.melodio.ai/cos-test/files/2990/20240625/789fb3899515486c9d6dc0827443e57c.mp3";

const props = defineProps({
  duration: {
    type: Number,
    default: 0,
  },
  url: {
    type: String,
    default: null,
  },
  type: {
    type: String,
    default: "normal",
  },
  waveformData: {
    type: Array,
    default: () => {
      return [];
    },
  },
});

const EditSelectAreaRender =
  props.type == "extend" ? EditSelectAreaExtend : EditSelectArea;
const emits = defineEmits(["syncWaveLoadingState"]);
const refDragSelect = ref(null);
const stateData = {};
const renderData = reactive({
  isPlaying: false,
  progress: 0,
  startTime: "00:00",
  duration: 0,
  sourceData: null,
  duration: props.duration,
});
const doTogglePlay = () => {
  refDragSelect.value.togglePlay();
};

const doSyncPlayState = (isPlaying) => {
  renderData.isPlaying = isPlaying;
};

const doSyncProgress = (progress, startTime) => {
  renderData.progress = progress;
  renderData.startTime = startTime;
};

const doSyncDuration = (duration) => {
  renderData.duration = duration;
};
const doSyncWaveLoadingState = (loading) => {
  emits("syncWaveLoadingState", loading);
};

const init = () => {
  // 初始化操作
};
onMounted(() => {
  init();
});
defineExpose({
  getRenerateStartTime() {
    return refDragSelect.value.getRenerateStartTime();
  },
});
</script>
<style lang="scss">
.reedit-song-edit {
  .reedit-song-edit-time-box {
    display: flex;
    padding-bottom: 8px;
    font-family: HarmonyOS Sans SC;
    font-size: 12px;
    font-weight: normal;
    line-height: 20px;
    color: #ffffff;
    .reedit-song-edit-time {
    }
  }
  .reedit-song-edit-main {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 12px;
    .reedit-song-edit-op {
      margin: 0 16px;
      height: 48px;
      width: 48px;
      border-radius: 28px;
      i {
        height: 20px;
        width: 20px;
      }
      .isplay-true {
        background: url("@/assets/img/play-light-ico.png");
        background-size: 100% 100%;
      }
      .isplay-false {
        background: url("@/assets/img/pause-light-ico.png");
        background-size: 100% 100%;
      }
    }
  }
  .reedit-song-edit-main-box {
    width: calc(100% - 48px - 16px * 2);
  }
}
</style>
